// version : 0.0.2
// LastEdit : AGALYA
// MODFIED DATE: 28-02-2026
// Last ADD : PAYLOAD DESTRUCTURED INSTEAD OF USING PAYLOAD.KEY

import { takeLatest, put, all, call } from 'redux-saga/effects';
import AuditingToolReportActionTypes from './auditing-tool-report.types';
import { auditingToolReportGet } from './auditing-tool-report.services';
import {
	getAuditingToolReportSuccess,
	getAuditingToolReportFailure,
	getAuditingToolReportResponseChanged,
} from './auditing-tool-report.action';

import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START GET AUDITING TOOL REPORT DETAILS  ******************** */

export function* getAuditingToolReportList({ payload }: any) {
	try {
		const key = 'GetAuditingToolKey';
		const { companyId, branchId, centerId, databaseName, fromDate, toDate, questionnaireID } =
			payload;
		const jsonData = {
			CompanyID: companyId,
			BranchID: branchId,
			CenterID: centerId,
			DatabaseName: databaseName,
			FromDate: fromDate,
			ToDate: toDate,
			QuestionID: questionnaireID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(auditingToolReportGet, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAuditingToolReportFailure(responseData.data));
		} else {
			yield put(getAuditingToolReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAuditingToolReportFailure(error));
	}
}

export function* resetgetAuditingToolReportListResponse() {
	yield put(getAuditingToolReportResponseChanged());
}

export function* ongetAuditingToolReportListDetails() {
	yield takeLatest(
		AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_START,
		getAuditingToolReportList,
	);
}

export function* ongetAuditingToolReportListResponseReset() {
	yield takeLatest(
		AuditingToolReportActionTypes.GET_AUDITING_TOOL_REPORT_LIST_RESPONSE_RESET,
		resetgetAuditingToolReportListResponse,
	);
}

/** *********************  END GET AUDITING TOOL REPORT DETAILS ******************** */

export function* auditingToolReportSaga() {
	yield all([
		call(ongetAuditingToolReportListDetails),
		call(ongetAuditingToolReportListResponseReset),
	]);
}
